import { AppBar, Container, DrawerProps, IconButton, Stack, Toolbar, Typography } from '@mui/material';
import { ResponsiveDrawer } from 'components/ResponsiveDrawer';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useIntl } from 'react-intl';
import { commonMessages } from 'utils/commonMessages';
import { useRecoilValue } from 'recoil';
import { tenantInfoState } from 'modules/application/atoms';
import { MobileZoomImage } from 'components/MobileZoomImage';

interface FindContractHelpDrawerProps extends Omit<DrawerProps, 'anchor' | 'desktopWidth' | 'onClose'> {
  onClose?: () => void;
}

export const FindContractHelpDrawer: React.FC<FindContractHelpDrawerProps> = ({ onClose, ...drawerProps }) => {
  const { formatMessage } = useIntl();
  const tenantInfo = useRecoilValue(tenantInfoState);

  return (
    <ResponsiveDrawer {...drawerProps} anchor='right' desktopWidth="800px" onClose={onClose}>
      <AppBar position='sticky' color='inherit' elevation={1}>
        <Toolbar>
          <Stack py={1} flexGrow={1}>
            <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ height: { xs: 40, sm: 60 } }}>
              <Typography variant='h5'>{formatMessage({ id: 'FindContractStepHelp.Title', defaultMessage: 'Find your contract and client number' })}</Typography>
              <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
      <Container>
        <Stack gap={2} py={2}>
          <Stack>
            <Typography variant='subtitle1' fontWeight='bold'>{formatMessage(commonMessages.contractNumber)}</Typography>
            <Typography>
              {formatMessage(
                {
                  id: 'FindContractStepHelp.HowToFindContractNumber',
                  defaultMessage: 'The contract number should be visible on the contract'
                }
              )}
            </Typography>
          </Stack>
          <Stack>
            <Typography variant='subtitle1' fontWeight='bold'>{formatMessage(commonMessages.clientNumber)}</Typography>
            <Typography>
              {formatMessage(
                {
                  id: 'FindContractStepHelp.HowToFindClientNumber',
                  defaultMessage: 'The client number should be visible on the contract'
                }
              )}
            </Typography>
          </Stack>
          <Stack>
            <Typography variant='subtitle1' fontWeight='bold'>{formatMessage({ id: 'FindContractStepHelp.BillExample', defaultMessage: 'Example of a contract' })}</Typography>
            <MobileZoomImage src={`/${tenantInfo.identifier}/api/contracts/example.png`} />
          </Stack>
        </Stack>
      </Container>
    </ResponsiveDrawer>
  );
};